import { DEFAULT_FONT_COLOR } from '../utils/constants';
import { theme } from '../domain/theme';
import { DEFAULT_SLIDE_MASTER } from './slide-master';
import { ShapeProps, Slide, TextPropsTextConfig } from '@features/powerpoint';

const BULLET_INDENT = 16;

const dividerLine = (options?: ShapeProps['options']): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.inmarketGreen,
      width: 2.25,
    },
    x: 0.93,
    y: 2.29,
    w: 0,
    h: 3.67,
    ...options,
  },
});

const objectiveListText = (text: string): TextPropsTextConfig[] => [
  {
    text: ' ',
    options: {
      bullet: { indent: BULLET_INDENT * 2, type: 'number' },
      color: theme.colors.inmarketGreen,
      fontSize: 14,
      bold: true,
    },
  },
  {
    text,
    options: { color: theme.colors.lightGray, fontSize: 14, bold: true },
  },
];

const whatsInsideListText = (text: string): TextPropsTextConfig[] => [
  {
    text: ' ',
    options: {
      bullet: { indent: BULLET_INDENT },
      color: theme.colors.inmarketGreen,
      fontSize: 16,
    },
  },
  { text, options: { color: DEFAULT_FONT_COLOR, fontSize: 16 } },
];

const campaignPerformanceList = (
  title: string,
  text: string
): TextPropsTextConfig[] => [
  {
    text: title.toUpperCase(),
    options: {
      fontSize: 12,
      color: theme.colors.inmarketGreen,
      bullet: { indent: BULLET_INDENT },
      indentLevel: 2,
      bold: true,
    },
  },
  {
    text,
    options: { fontSize: 12, color: 'FFFFFF' },
  },
];

export const agendaSlide = (
  campaignPerformanceItems: { title: string; text: string }[]
): Slide => {
  const campaignPerformanceTexts = campaignPerformanceItems.map(item =>
    campaignPerformanceList(item.title, item.text)
  );

  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: [
      {
        text: [
          {
            text: "Today's ",
            options: {
              fontSize: 32,
              color: DEFAULT_FONT_COLOR,
              bold: true,
            },
          },
          {
            text: 'Objective',
            options: {
              fontSize: 32,
              color: theme.colors.inmarketGreen,
              bold: true,
            },
          },
        ],
        options: {
          x: 1.05,
          y: 2.18,
          h: 0.64,
          w: 9.86,
        },
      },
      {
        text: [
          ...objectiveListText('Discuss campaign outcomes'),
          ...objectiveListText('Quantify performance & optimizations'),
          ...objectiveListText('Share intelligence for future success'),
        ],
        options: {
          h: 1.28,
          w: 4.68,
          x: 1.05,
          y: 3.09,
          paraSpaceAfter: 14,
        },
      },
      {
        text: 'Agenda',
        options: {
          x: 0.74,
          y: 0.74,
          w: 12.59,
          h: 0.57,
          fontSize: 28,
          color: DEFAULT_FONT_COLOR,
          bold: true,
        },
      },
      {
        text: [
          {
            text: "What's ",
            options: {
              fontSize: 32,
              color: DEFAULT_FONT_COLOR,
              bold: true,
            },
          },
          {
            text: 'inside',
            options: {
              fontSize: 32,
              color: theme.colors.inmarketGreen,
              bold: true,
            },
          },
        ],
        options: {
          x: 6.77,
          y: 2.16,
          w: 9.86,
          h: 0.64,
        },
      },
      {
        text: [
          ...whatsInsideListText('Introduction'),
          ...whatsInsideListText('Campaign Overview'),
          ...whatsInsideListText('Campaign Performance'),
          ...campaignPerformanceTexts.flat(),
          ...whatsInsideListText('Summary and Recommendations'),
          ...whatsInsideListText('Insights'),
        ],
        options: {
          x: 6.77,
          y: 2.9,
          w: 5.78,
          h: 3.39,
          paraSpaceAfter: 10,
          valign: 'top',
        },
      },
    ],
    shapes: [dividerLine(), dividerLine({ x: 6.66 })],
  };
};
